import { render } from "./JournalAuthorPanel.vue?vue&type=template&id=06a466ce&scoped=true"
import script from "./JournalAuthorPanel.vue?vue&type=script&lang=js"
export * from "./JournalAuthorPanel.vue?vue&type=script&lang=js"

import "./JournalAuthorPanel.vue?vue&type=style&index=0&id=06a466ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a466ce"]])

export default __exports__